import script from "./EntityCategoryManage.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityCategoryManage.vue?vue&type=script&setup=true&lang=js"

import "./EntityCategoryManage.vue?vue&type=style&index=0&id=25d93aa6&scoped=true&lang=scss"

import exportComponent from "/Users/cricle/Documents/monetware/code/web/knowledgeGraph-html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25d93aa6"]])

export default __exports__